import Route from "vue-routisan";
import isGuest from "@/http/routes/middlewares/isGuest";

Route.group({}, () => {
  Route.group({prefix: "finance", beforeEnter: isGuest}, () => {
    Route.view("/simulation", () =>
      import(/* webpackChunkName: "finance" */ "src/resources/views/guest/CreditSimulation")
    )
      .name("finance_simulation")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "finance" */ "src/resources/views/guest/Layout/CreditLayout.vue")
        }
      });

    Route.view("/register", () =>
      import(/* webpackChunkName: "finance" */ "src/resources/views/guest/TransporterRegister")
    )
      .name("finance_register")
      .options({
        meta: {
          layout: () =>
            import(/* webpackChunkName: "finance" */ "src/resources/views/guest/Layout/CreditLayout.vue")
        }
      });
  })
})

export default Route.all();
